export default __webpack_public_path__ + "static/media/logo.7354cf1a.png";